"use client";

import { useEffect } from "react";

import { recordArticleView } from "@/lib/api-client-browser";

interface ArticleViewTrackerProps {
  slug: string;
}

/**
 * 記事詳細ページの PV を記録するクライアントコンポーネント。
 * useEffect でマウント時に POST /api/external/v1/articles/:slug/view を呼ぶ。
 * - credentials: "include" で _faq_vid Cookie を送信
 * - fire-and-forget: エラーが起きてもユーザー体験に影響しない
 * - SSR キャッシュと干渉しない
 * - ボット（JS 未実行）は自然に除外される
 */
export function ArticleViewTracker({ slug }: ArticleViewTrackerProps) {
  useEffect(() => {
    recordArticleView(slug).catch(() => {
      // fire-and-forget: PV 記録の失敗はユーザー体験に影響させない
    });
  }, [slug]);

  return null;
}
